import React from 'react';
import { Collapse } from 'antd';
import PlusThin from 'assests/icons/plus-thin.icon';
import CollapseIcon from 'assests/icons/collapse.icon';
import './accordion.less';

const { Panel } = Collapse;

const Accordion = (props) => {
  return (
    <Collapse
      className="accordion"
      accordion
      expandIcon={({ isActive }) =>
        !isActive ? <PlusThin /> : <CollapseIcon />
      }
    >
      {props.list.map((item, index) => (
        <Panel header={item.header} key={index}>
          <p dangerouslySetInnerHTML={{__html: item.content}} ></p>
        </Panel>
      ))}
    </Collapse>
  );
};

export default Accordion;
